// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ng2-pdf-viewer-container {
  overflow-x: auto;
  position: absolute;
  height: 100%;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

:host {
  display: block;
  position: relative;
}

:host ::ng-deep {
  /* Copyright 2014 Mozilla Foundation
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *     http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */
  --pdfViewer-padding-bottom: 0;
  --page-margin: 1px auto -8px;
  --page-border: 9px solid transparent;
  --spreadHorizontalWrapped-margin-LR: -3.5px;
  --viewer-container-height: 0;
  --annotation-unfocused-field-background: url("data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>");
  --xfa-unfocused-field-background: var(
    --annotation-unfocused-field-background
  );
  --page-border-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAA1ElEQVQ4jbWUWw6EIAxFy2NFs/8NzR4UJhpqLsdi5mOmSSMUOfYWqv3S0gMr4XlYH/64gZa/gN3ANYA7KAXALt4ktoQ5MI9YxqaG8bWmsIysMuT6piSQCa4whZThCu8CM4zP9YJaKci9jicPq3NcBWYoPMGUlhG7ivtkB+gVyFY75wXghOvh8t5mto1Mdim6e+MBqH6XsY+YAwjpq3vGF7weTWQptLEDVCZvPTMl5JZZsdh47FHW6qFMyvLYqjcnmdFfY9Xk/KDOlzCusX2mi/ofM7MPkzBcSp4Q1/wAAAAASUVORK5CYII=")
    9 9 repeat;
  --scale-factor: 1;
  --focus-outline: solid 2px blue;
  --hover-outline: dashed 2px blue;
  --freetext-line-height: 1.35;
  --freetext-padding: 2px;
  --editorInk-editing-cursor: pointer;
  /* Only necessary in Google Chrome, see issue 14205, and most unfortunately
   * the problem doesn't show up in "text" reference tests. */
  /* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */
}
@media screen and (forced-colors: active) {
  :host ::ng-deep {
    --pdfViewer-padding-bottom: 9px;
    --page-margin: 8px auto -1px;
    --page-border: 1px solid CanvasText;
    --page-border-image: none;
    --spreadHorizontalWrapped-margin-LR: 3.5px;
  }
}
@media (forced-colors: active) {
  :host ::ng-deep {
    --focus-outline: solid 3px ButtonText;
    --hover-outline: dashed 3px ButtonText;
  }
}
:host ::ng-deep .textLayer {
  position: absolute;
  text-align: initial;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
  line-height: 1;
  text-size-adjust: none;
  forced-color-adjust: none;
}
:host ::ng-deep .textLayer span,
:host ::ng-deep .textLayer br {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
}
:host ::ng-deep .textLayer span.markedContent {
  top: 0;
  height: 0;
}
:host ::ng-deep .textLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: rgb(180, 0, 170);
  border-radius: 4px;
}
:host ::ng-deep .textLayer .highlight.appended {
  position: initial;
}
:host ::ng-deep .textLayer .highlight.begin {
  border-radius: 4px 0 0 4px;
}
:host ::ng-deep .textLayer .highlight.end {
  border-radius: 0 4px 4px 0;
}
:host ::ng-deep .textLayer .highlight.middle {
  border-radius: 0;
}
:host ::ng-deep .textLayer .highlight.selected {
  background-color: rgb(0, 100, 0);
}
:host ::ng-deep .textLayer ::selection {
  background: rgb(0, 0, 255);
}
:host ::ng-deep .textLayer br::selection {
  background: transparent;
}
:host ::ng-deep .textLayer .endOfContent {
  display: block;
  position: absolute;
  left: 0;
  top: 100%;
  right: 0;
  bottom: 0;
  z-index: -1;
  cursor: default;
  user-select: none;
}
:host ::ng-deep .textLayer .endOfContent.active {
  top: 0;
}
@media (forced-colors: active) {
  :host ::ng-deep .annotationLayer .textWidgetAnnotation input:required,
  :host ::ng-deep .annotationLayer .textWidgetAnnotation textarea:required,
  :host ::ng-deep .annotationLayer .choiceWidgetAnnotation select:required,
  :host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:required,
  :host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input:required {
    outline: 1.5px solid selectedItem;
  }
}
:host ::ng-deep .annotationLayer {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  transform-origin: 0 0;
}
:host ::ng-deep .annotationLayer section {
  position: absolute;
  text-align: initial;
  pointer-events: auto;
  box-sizing: border-box;
  transform-origin: 0 0;
}
:host ::ng-deep .annotationLayer .linkAnnotation > a,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.pushButton > a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.pushButton > canvas {
  width: 100%;
  height: 100%;
}
:host ::ng-deep .annotationLayer .linkAnnotation > a:hover,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.pushButton > a:hover {
  opacity: 0.2;
  background: rgb(255, 255, 0);
  box-shadow: 0 2px 10px rgb(255, 255, 0);
}
:host ::ng-deep .annotationLayer .textAnnotation img {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation input,
:host ::ng-deep .annotationLayer .textWidgetAnnotation textarea,
:host ::ng-deep .annotationLayer .choiceWidgetAnnotation select,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input {
  background-image: var(--annotation-unfocused-field-background);
  border: 1px solid transparent;
  box-sizing: border-box;
  font: calc(9px * var(--scale-factor)) sans-serif;
  height: 100%;
  margin: 0;
  vertical-align: top;
  width: 100%;
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation input:required,
:host ::ng-deep .annotationLayer .textWidgetAnnotation textarea:required,
:host ::ng-deep .annotationLayer .choiceWidgetAnnotation select:required,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:required,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input:required {
  outline: 1.5px solid red;
}
:host ::ng-deep .annotationLayer .choiceWidgetAnnotation select option {
  padding: 0;
}
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input {
  border-radius: 50%;
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation textarea {
  resize: none;
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation input[disabled],
:host ::ng-deep .annotationLayer .textWidgetAnnotation textarea[disabled],
:host ::ng-deep .annotationLayer .choiceWidgetAnnotation select[disabled],
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input[disabled] {
  background: none;
  border: 1px solid transparent;
  cursor: not-allowed;
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation input:hover,
:host ::ng-deep .annotationLayer .textWidgetAnnotation textarea:hover,
:host ::ng-deep .annotationLayer .choiceWidgetAnnotation select:hover,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:hover,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input:hover {
  border: 1px solid rgb(0, 0, 0);
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation input:focus,
:host ::ng-deep .annotationLayer .textWidgetAnnotation textarea:focus,
:host ::ng-deep .annotationLayer .choiceWidgetAnnotation select:focus {
  background: none;
  border: 1px solid transparent;
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation input :focus,
:host ::ng-deep .annotationLayer .textWidgetAnnotation textarea :focus,
:host ::ng-deep .annotationLayer .choiceWidgetAnnotation select :focus,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox :focus,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton :focus {
  background-image: none;
  background-color: transparent;
  outline: auto;
}
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
  background-color: CanvasText;
  content: "";
  display: block;
  position: absolute;
}
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
  height: 80%;
  left: 45%;
  width: 1px;
}
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before {
  transform: rotate(45deg);
}
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {
  transform: rotate(-45deg);
}
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {
  border-radius: 50%;
  height: 50%;
  left: 30%;
  top: 20%;
  width: 50%;
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation input.comb {
  font-family: monospace;
  padding-left: 2px;
  padding-right: 0;
}
:host ::ng-deep .annotationLayer .textWidgetAnnotation input.comb:focus {
  /*
   * Letter spacing is placed on the right side of each character. Hence, the
   * letter spacing of the last character may be placed outside the visible
   * area, causing horizontal scrolling. We avoid this by extending the width
   * when the element has focus and revert this when it loses focus.
   */
  width: 103%;
}
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.checkBox input,
:host ::ng-deep .annotationLayer .buttonWidgetAnnotation.radioButton input {
  appearance: none;
}
:host ::ng-deep .annotationLayer .popupTriggerArea {
  height: 100%;
  width: 100%;
}
:host ::ng-deep .annotationLayer .popupWrapper {
  position: absolute;
  font-size: calc(9px * var(--scale-factor));
  width: 100%;
  min-width: calc(180px * var(--scale-factor));
  pointer-events: none;
}
:host ::ng-deep .annotationLayer .popup {
  position: absolute;
  max-width: calc(180px * var(--scale-factor));
  background-color: rgb(255, 255, 153);
  box-shadow: 0 calc(2px * var(--scale-factor)) calc(5px * var(--scale-factor)) rgb(136, 136, 136);
  border-radius: calc(2px * var(--scale-factor));
  padding: calc(6px * var(--scale-factor));
  margin-left: calc(5px * var(--scale-factor));
  cursor: pointer;
  font: message-box;
  white-space: normal;
  word-wrap: break-word;
  pointer-events: auto;
}
:host ::ng-deep .annotationLayer .popup > * {
  font-size: calc(9px * var(--scale-factor));
}
:host ::ng-deep .annotationLayer .popup h1 {
  display: inline-block;
}
:host ::ng-deep .annotationLayer .popupDate {
  display: inline-block;
  margin-left: calc(5px * var(--scale-factor));
}
:host ::ng-deep .annotationLayer .popupContent {
  border-top: 1px solid rgb(51, 51, 51);
  margin-top: calc(2px * var(--scale-factor));
  padding-top: calc(2px * var(--scale-factor));
}
:host ::ng-deep .annotationLayer .richText > * {
  white-space: pre-wrap;
  font-size: calc(9px * var(--scale-factor));
}
:host ::ng-deep .annotationLayer .highlightAnnotation,
:host ::ng-deep .annotationLayer .underlineAnnotation,
:host ::ng-deep .annotationLayer .squigglyAnnotation,
:host ::ng-deep .annotationLayer .strikeoutAnnotation,
:host ::ng-deep .annotationLayer .freeTextAnnotation,
:host ::ng-deep .annotationLayer .lineAnnotation svg line,
:host ::ng-deep .annotationLayer .squareAnnotation svg rect,
:host ::ng-deep .annotationLayer .circleAnnotation svg ellipse,
:host ::ng-deep .annotationLayer .polylineAnnotation svg polyline,
:host ::ng-deep .annotationLayer .polygonAnnotation svg polygon,
:host ::ng-deep .annotationLayer .caretAnnotation,
:host ::ng-deep .annotationLayer .inkAnnotation svg polyline,
:host ::ng-deep .annotationLayer .stampAnnotation,
:host ::ng-deep .annotationLayer .fileAttachmentAnnotation {
  cursor: pointer;
}
:host ::ng-deep .annotationLayer section svg {
  position: absolute;
  width: 100%;
  height: 100%;
}
:host ::ng-deep .annotationLayer .annotationTextContent {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  color: transparent;
  user-select: none;
  pointer-events: none;
}
:host ::ng-deep .annotationLayer .annotationTextContent span {
  width: 100%;
  display: inline-block;
}
@media (forced-colors: active) {
  :host ::ng-deep .xfaLayer *:required {
    outline: 1.5px solid selectedItem;
  }
}
:host ::ng-deep .xfaLayer .highlight {
  margin: -1px;
  padding: 1px;
  background-color: rgb(239, 203, 237);
  border-radius: 4px;
}
:host ::ng-deep .xfaLayer .highlight.appended {
  position: initial;
}
:host ::ng-deep .xfaLayer .highlight.begin {
  border-radius: 4px 0 0 4px;
}
:host ::ng-deep .xfaLayer .highlight.end {
  border-radius: 0 4px 4px 0;
}
:host ::ng-deep .xfaLayer .highlight.middle {
  border-radius: 0;
}
:host ::ng-deep .xfaLayer .highlight.selected {
  background-color: rgb(203, 223, 203);
}
:host ::ng-deep .xfaLayer ::selection {
  background: rgb(0, 0, 255);
}
:host ::ng-deep .xfaPage {
  overflow: hidden;
  position: relative;
}
:host ::ng-deep .xfaContentarea {
  position: absolute;
}
:host ::ng-deep .xfaPrintOnly {
  display: none;
}
:host ::ng-deep .xfaLayer {
  position: absolute;
  text-align: initial;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  line-height: 1.2;
}
:host ::ng-deep .xfaLayer * {
  color: inherit;
  font: inherit;
  font-style: inherit;
  font-weight: inherit;
  font-kerning: inherit;
  letter-spacing: -0.01px;
  text-align: inherit;
  text-decoration: inherit;
  box-sizing: border-box;
  background-color: transparent;
  padding: 0;
  margin: 0;
  pointer-events: auto;
  line-height: inherit;
}
:host ::ng-deep .xfaLayer *:required {
  outline: 1.5px solid red;
}
:host ::ng-deep .xfaLayer div {
  pointer-events: none;
}
:host ::ng-deep .xfaLayer svg {
  pointer-events: none;
}
:host ::ng-deep .xfaLayer svg * {
  pointer-events: none;
}
:host ::ng-deep .xfaLayer a {
  color: blue;
}
:host ::ng-deep .xfaRich li {
  margin-left: 3em;
}
:host ::ng-deep .xfaFont {
  color: black;
  font-weight: normal;
  font-kerning: none;
  font-size: 10px;
  font-style: normal;
  letter-spacing: 0;
  text-decoration: none;
  vertical-align: 0;
}
:host ::ng-deep .xfaCaption {
  overflow: hidden;
  flex: 0 0 auto;
}
:host ::ng-deep .xfaCaptionForCheckButton {
  overflow: hidden;
  flex: 1 1 auto;
}
:host ::ng-deep .xfaLabel {
  height: 100%;
  width: 100%;
}
:host ::ng-deep .xfaLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
:host ::ng-deep .xfaRight {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
:host ::ng-deep .xfaLeft > .xfaCaption,
:host ::ng-deep .xfaLeft > .xfaCaptionForCheckButton,
:host ::ng-deep .xfaRight > .xfaCaption,
:host ::ng-deep .xfaRight > .xfaCaptionForCheckButton {
  max-height: 100%;
}
:host ::ng-deep .xfaTop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
:host ::ng-deep .xfaBottom {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
}
:host ::ng-deep .xfaTop > .xfaCaption,
:host ::ng-deep .xfaTop > .xfaCaptionForCheckButton,
:host ::ng-deep .xfaBottom > .xfaCaption,
:host ::ng-deep .xfaBottom > .xfaCaptionForCheckButton {
  width: 100%;
}
:host ::ng-deep .xfaBorder {
  background-color: transparent;
  position: absolute;
  pointer-events: none;
}
:host ::ng-deep .xfaWrapped {
  width: 100%;
  height: 100%;
}
:host ::ng-deep .xfaTextfield:focus,
:host ::ng-deep .xfaSelect:focus {
  background-image: none;
  background-color: transparent;
  outline: auto;
  outline-offset: -1px;
}
:host ::ng-deep .xfaCheckbox:focus,
:host ::ng-deep .xfaRadio:focus {
  outline: auto;
}
:host ::ng-deep .xfaTextfield,
:host ::ng-deep .xfaSelect {
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  border: none;
  resize: none;
  background-image: var(--xfa-unfocused-field-background);
}
:host ::ng-deep .xfaTop > .xfaTextfield,
:host ::ng-deep .xfaTop > .xfaSelect,
:host ::ng-deep .xfaBottom > .xfaTextfield,
:host ::ng-deep .xfaBottom > .xfaSelect {
  flex: 0 1 auto;
}
:host ::ng-deep .xfaButton {
  cursor: pointer;
  width: 100%;
  height: 100%;
  border: none;
  text-align: center;
}
:host ::ng-deep .xfaLink {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
:host ::ng-deep .xfaCheckbox,
:host ::ng-deep .xfaRadio {
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  border: none;
}
:host ::ng-deep .xfaRich {
  white-space: pre-wrap;
  width: 100%;
  height: 100%;
}
:host ::ng-deep .xfaImage {
  object-position: left top;
  object-fit: contain;
  width: 100%;
  height: 100%;
}
:host ::ng-deep .xfaLrTb,
:host ::ng-deep .xfaRlTb,
:host ::ng-deep .xfaTb {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host ::ng-deep .xfaLr {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
:host ::ng-deep .xfaRl {
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
}
:host ::ng-deep .xfaTb > div {
  justify-content: left;
}
:host ::ng-deep .xfaPosition {
  position: relative;
}
:host ::ng-deep .xfaArea {
  position: relative;
}
:host ::ng-deep .xfaValignMiddle {
  display: flex;
  align-items: center;
}
:host ::ng-deep .xfaTable {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host ::ng-deep .xfaTable .xfaRow {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
:host ::ng-deep .xfaTable .xfaRlRow {
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
  flex: 1;
}
:host ::ng-deep .xfaTable .xfaRlRow > div {
  flex: 1;
}
:host ::ng-deep .xfaNonInteractive input,
:host ::ng-deep .xfaNonInteractive textarea,
:host ::ng-deep .xfaDisabled input,
:host ::ng-deep .xfaDisabled textarea,
:host ::ng-deep .xfaReadOnly input,
:host ::ng-deep .xfaReadOnly textarea {
  background: initial;
}
@media print {
  :host ::ng-deep .xfaTextfield,
  :host ::ng-deep .xfaSelect {
    background: transparent;
  }
  :host ::ng-deep .xfaSelect {
    appearance: none;
    text-indent: 1px;
    text-overflow: "";
  }
}
:host ::ng-deep [data-editor-rotation="90"] {
  transform: rotate(90deg);
}
:host ::ng-deep [data-editor-rotation="180"] {
  transform: rotate(180deg);
}
:host ::ng-deep [data-editor-rotation="270"] {
  transform: rotate(270deg);
}
:host ::ng-deep .annotationEditorLayer {
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  font-size: calc(100px * var(--scale-factor));
  transform-origin: 0 0;
}
:host ::ng-deep .annotationEditorLayer .selectedEditor {
  outline: var(--focus-outline);
  resize: none;
}
:host ::ng-deep .annotationEditorLayer .freeTextEditor {
  position: absolute;
  background: transparent;
  border-radius: 3px;
  padding: calc(var(--freetext-padding) * var(--scale-factor));
  resize: none;
  width: auto;
  height: auto;
  z-index: 1;
  transform-origin: 0 0;
  touch-action: none;
}
:host ::ng-deep .annotationEditorLayer .freeTextEditor .internal {
  background: transparent;
  border: none;
  top: 0;
  left: 0;
  overflow: visible;
  white-space: nowrap;
  resize: none;
  font: 10px sans-serif;
  line-height: var(--freetext-line-height);
}
:host ::ng-deep .annotationEditorLayer .freeTextEditor .overlay {
  position: absolute;
  display: none;
  background: transparent;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
:host ::ng-deep .annotationEditorLayer .freeTextEditor .overlay.enabled {
  display: block;
}
:host ::ng-deep .annotationEditorLayer .freeTextEditor .internal:empty::before {
  content: attr(default-content);
  color: gray;
}
:host ::ng-deep .annotationEditorLayer .freeTextEditor .internal:focus {
  outline: none;
}
:host ::ng-deep .annotationEditorLayer .inkEditor.disabled {
  resize: none;
}
:host ::ng-deep .annotationEditorLayer .inkEditor.disabled.selectedEditor {
  resize: horizontal;
}
:host ::ng-deep .annotationEditorLayer .freeTextEditor:hover:not(.selectedEditor),
:host ::ng-deep .annotationEditorLayer .inkEditor:hover:not(.selectedEditor) {
  outline: var(--hover-outline);
}
:host ::ng-deep .annotationEditorLayer .inkEditor {
  position: absolute;
  background: transparent;
  border-radius: 3px;
  overflow: auto;
  width: 100%;
  height: 100%;
  z-index: 1;
  transform-origin: 0 0;
  cursor: auto;
}
:host ::ng-deep .annotationEditorLayer .inkEditor.editing {
  resize: none;
  cursor: var(--editorInk-editing-cursor), pointer;
}
:host ::ng-deep .annotationEditorLayer .inkEditor .inkEditorCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  touch-action: none;
}
:host ::ng-deep [data-main-rotation="90"] {
  transform: rotate(90deg) translateY(-100%);
}
:host ::ng-deep [data-main-rotation="180"] {
  transform: rotate(180deg) translate(-100%, -100%);
}
:host ::ng-deep [data-main-rotation="270"] {
  transform: rotate(270deg) translateX(-100%);
}
:host ::ng-deep .pdfViewer {
  padding-bottom: var(--pdfViewer-padding-bottom);
}
:host ::ng-deep .pdfViewer .canvasWrapper {
  overflow: hidden;
}
:host ::ng-deep .pdfViewer .page {
  direction: ltr;
  width: 816px;
  height: 1056px;
  margin: var(--page-margin);
  position: relative;
  overflow: visible;
  border: var(--page-border);
  border-image: var(--page-border-image);
  background-clip: content-box;
  background-color: rgb(255, 255, 255);
}
:host ::ng-deep .pdfViewer .dummyPage {
  position: relative;
  width: 0;
  height: var(--viewer-container-height);
}
:host ::ng-deep .pdfViewer.removePageBorders .page {
  margin: 0 auto 10px;
  border: none;
}
:host ::ng-deep .pdfViewer.singlePageView {
  display: inline-block;
}
:host ::ng-deep .pdfViewer.singlePageView .page {
  margin: 0;
  border: none;
}
:host ::ng-deep .pdfViewer.scrollHorizontal,
:host ::ng-deep .pdfViewer.scrollWrapped,
:host ::ng-deep .spread {
  margin-left: 3.5px;
  margin-right: 3.5px;
  text-align: center;
}
:host ::ng-deep .pdfViewer.scrollHorizontal,
:host ::ng-deep .spread {
  white-space: nowrap;
}
:host ::ng-deep .pdfViewer.removePageBorders,
:host ::ng-deep .pdfViewer.scrollHorizontal .spread,
:host ::ng-deep .pdfViewer.scrollWrapped .spread {
  margin-left: 0;
  margin-right: 0;
}
:host ::ng-deep .spread .page,
:host ::ng-deep .spread .dummyPage,
:host ::ng-deep .pdfViewer.scrollHorizontal .page,
:host ::ng-deep .pdfViewer.scrollWrapped .page,
:host ::ng-deep .pdfViewer.scrollHorizontal .spread,
:host ::ng-deep .pdfViewer.scrollWrapped .spread {
  display: inline-block;
  vertical-align: middle;
}
:host ::ng-deep .spread .page,
:host ::ng-deep .pdfViewer.scrollHorizontal .page,
:host ::ng-deep .pdfViewer.scrollWrapped .page {
  margin-left: var(--spreadHorizontalWrapped-margin-LR);
  margin-right: var(--spreadHorizontalWrapped-margin-LR);
}
:host ::ng-deep .pdfViewer.removePageBorders .spread .page,
:host ::ng-deep .pdfViewer.removePageBorders.scrollHorizontal .page,
:host ::ng-deep .pdfViewer.removePageBorders.scrollWrapped .page {
  margin-left: 5px;
  margin-right: 5px;
}
:host ::ng-deep .pdfViewer .page canvas {
  margin: 0;
  display: block;
}
:host ::ng-deep .pdfViewer .page canvas[hidden] {
  display: none;
}
:host ::ng-deep .pdfViewer .page .loadingIcon {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/gif;base64,R0lGODlhGAAYAPQQAM7Ozvr6+uDg4LCwsOjo6I6OjsjIyJycnNjY2KioqMDAwPLy8nZ2doaGhri4uGhoaP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/ilPcHRpbWl6ZWQgd2l0aCBodHRwczovL2V6Z2lmLmNvbS9vcHRpbWl6ZQAh+QQJBwAQACwAAAAAGAAYAAAFmiAkjiTkOGVaBgjZNGSgkgKjjM8zLoI8iy+BKCdiCX8iBeMAhEEIPRXLxViYUE9CbCQoFAzFhHY3zkaT3oPvBz1zE4UBsr1eWZH4vAowOBwGAHk8AoQLfH6Agm0Ed3qOAXWOIgQKiWyFJQgDgJEpdG+WEACNEFNFmKVlVzJQk6qdkwqBoi1mebJ3ALNGeIZHtGSwNDS1RZKueCEAIfkECQcAEAAsAAAAABgAGAAABZcgJI4kpChlWgYCWRQkEKgjURgjw4zOg9CjVwuiEyEeO6CxkBC9nA+HiuUqLEyoBZI0Mx4SAFFgQCDZuguBoGv6Dtg0gvpqdhxQQDkBzuUr/4A1JwMKP39pc2mDhYCIc4GQYn6QCwCMeY91l0p6dBAEJ0OfcFRimZ91Mwt0alxxAIZyRmuAsKxDLKKvZbM1tJxmvGKRpn8hACH5BAkHABAALAAAAAAYABgAAAWhICSOJGQYZVoGAnkcJBKoI3EAY1GMCtPSosSBINKJBIwGkHdwBGGQA0OhYpEGQxNqkYzNIITBACEKKBaxxNfBeOCO4vMy0Hg8nDHFeCktkKtfNAtoS4UqAicKBj9zBAKPC4iKi4aRkISGmWWBmjUIAIyHkCUEAKCVo2WmREecVqoCgZhgP4NHrGWCj7e3szSpuxAsoVWxnp6cVV4kyZW+KSEAIfkECQcAEAAsAAAAABgAGAAABZkgJI4kBABlWgYEOQykEKgjMSDjcYxG0dKi108nEhQKQN4rCIMkCgbawjWYnSCLY2yGVSgEooBhWqsGGwxc0RtNBgoMhmJ1QgETjANYFeBKyUmBKQQIdT9JDmgPDQ6EhoKJD4sOgpWWgiwChyqEBH5hmptSoSOZgJ4kLKWkYTF7C2SaqaM/hEWygay4mYG8t6uffFuzl1iANCEAIfkECQcAEAAsAAAAABgAGAAABZ0gJI4khCBlmhKkopBCoI6LIozDMAIHO4uuBVBnOiR+I4FrCDwAZsKdQnaCLIwwmRUA8JmioprWUCjcwlwUMnAoG0qL03k2KCS8cC0UjOzDCQKBfHQFDAwFU4CCfgqFhy9+kZJWgzSKSAcPZn+BfQENDw8OljGWJAFeDoZPYTBnC1GdSXqnsoBolSulX2GyP6hgvnG0KrS3NJNhuSQhACH5BAkHABAALAAAAAAYABgAAAWaICSOJCQIZZoupGGQRKCOC0CMijIiwz2LABtQZxoMfjQhxAXszWQ7gOwECRhh0MCJJRJARTUoIHFAgbfI6uBwAJS01J/i4PClVYHvfV8lbLlIBmwFbQt+aGmChG18jXeGT4dICQxlb4g/AQUMDER9XjR6BAdiDQwINDBmkAsPDVh4cX4imw53iLKuaVqAcUsPqEiidkt6j4AzIQAh+QQJBwAQACwAAAAAGAAYAAAFmSAkjiREEGWaBiSCtCoZCMsIAKOg1LEo0KKbaKFQ9EYLoOkFuQlirNxzCQkUW9GZ0hQd4nyDAWr4G/esYSbyZFYZwu3jqiuvr8u8I2BwOAwASXh1e31/doeHC3klWnElfAlTd46MfQUGk2stCVEGBQWSdCciDg5VDAVYKoEiDQ0iBwxGcj9RDw8+qHIzebc2DJJQJK6qiKVyIQAh+QQJBwAQACwAAAAAGAAYAAAFmSAkjiS0LGWaBiRBtCoZCKgoCCMB1DF0sz6cCQDo5W62l28XAyZFpyECBv3lnCbhUqHMIo0Qg4Jbmn1jRCa4iV27TzfXGjEecOFWMN1OdvvfPGUuXSoKBw6EXokrAwcHRVU0UAeEBANAAAmUI1gNDyhjJgUHLW0iDg8FIqOnBQZrDA9TELE2rEYIDw4jta2LMpCrqld/YQpgIQAh+QQJBwAQACwAAAAAGAAYAAAFmyAkjiS0LGWaBiRBkKw6BgIqCsJcyyMe4yJajhcEml5H26o1PN2QQd3uFiv2AADlAgflIbDdZLgkABOJgep5LfWty4p4zeU+w+XsvJWXliEKDwdEBgMKYQ4PDw1qK3EDCCMAiQ5BCV0LCj+FSDQkgCgGBiYHAy2MIgoMghAHqw4HAGsNDEMFBTekdgwKI7aRB2MwkL2rVHoQoWchACH5BAkHABAALAAAAAAYABgAAAWWICSOJLQsZZoGJEGQrDoGAioKwlzLIx7jIlqOFwSaXkfbqjU83ZBB3e4WK0qrCxyU55peid0qcUwuixyNx6PhILsAcAJazXYj4lvz2MkLiFsHDAlEcABKZwwMBX8pBgoKQxAIigpBA1sLBj+PSDQkB4uSACYDlTMyBgWDEKVnl2QFBUigN61gBQYjtLV5JZ4jtlR6omMhACH5BAkHABAALAAAAAAYABgAAAWaICSOJLQsZZoGJEGQrDoGAioKwlzLIx7jIlqOFwSaXkdbidYanm7I4AjwYDh6saJuJ3JUG1mZi9srPA7EcRimJLrfJYWZUVC8TziXnEG3u/E+cIJaPAFrPQl1aQAIbRAGBZGHJQiMUQKRBkEKbQsAPZaEXQcslSYKmjMyAAdXj34ACkNEiUgDA5t+PAQHn6Ogjkuzry2DNwhuIQAh+QQFBwAQACwAAAAAGAAYAAAFnCAkjiS0LGVaBgBJEGSguo8zCsK4CPIsMg+ECCcKEH0ix6MwhJl4KiOp8UCdmrEbo6EoHpxF8A6aBBZ6vhf5dmAkkGr0CoWs21WGQ2FvsI9xC3l7B311fy93iWGKJQQOhHCAJQB6A3IqcWwJLU90i2FkUiMKlhBELEI6MwgDXRAGhQgAYD6tTqRFAJxpA6mvrqazSKJJhUWMpjlIIQA7") center no-repeat;
}
:host ::ng-deep .pdfViewer .page .loadingIcon.notVisible {
  background: none;
}
:host ::ng-deep .pdfViewer.enablePermissions .textLayer span {
  user-select: none !important;
  cursor: not-allowed;
}
:host ::ng-deep .pdfPresentationMode .pdfViewer {
  padding-bottom: 0;
}
:host ::ng-deep .pdfPresentationMode .spread {
  margin: 0;
}
:host ::ng-deep .pdfPresentationMode .pdfViewer .page {
  margin: 0 auto;
  border: 2px solid transparent;
}`, "",{"version":3,"sources":["webpack://./src/activities/pdf-viewer/pdf-viewer-new/pdf-viewer-new.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE;;;;;;;;;;;;;GAAA;EAcA,6BAAA;EACA,4BAAA;EACA,oCAAA;EACA,2CAAA;EACA,4BAAA;EACA,+NAAA;EACA;;GAAA;EAGA;cAAA;EAEA,iBAAA;EAEA,+BAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,mCAAA;EAwCA;6DAAA;EA0CA,oEAAA;AA/EF;AADE;EAlCF;IAmCI,+BAAA;IACA,4BAAA;IACA,mCAAA;IACA,yBAAA;IACA,0CAAA;EAIF;AACF;AAFE;EA1CF;IA2CI,qCAAA;IACA,sCAAA;EAKF;AACF;AAHE;EACE,kBAAA;EACA,mBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EAGA,sBAAA;EACA,yBAAA;AAKJ;AAFE;;EAEE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AAIJ;AACE;EACE,MAAA;EACA,SAAA;AACJ;AAEE;EACE,YAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;AAAJ;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,0BAAA;AAFJ;AAKE;EACE,0BAAA;AAHJ;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,gCAAA;AALJ;AAYE;EACE,0BAAA;AAPJ;AAeE;EACE,uBAAA;AAVJ;AAaE;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EAGA,iBAAA;AAXJ;AAcE;EACE,MAAA;AAZJ;AAeE;EACE;;;;;IAKE,iCAAA;EAbJ;AACF;AAgBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,qBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;AAfJ;AAkBE;;EAEE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,YAAA;AAjBJ;AAoBE;;EAEE,YAAA;EACA,4BAAA;EACA,uCAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAnBJ;AAsBE;;;;;EAKE,8DAAA;EACA,6BAAA;EACA,sBAAA;EACA,gDAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AApBJ;AAuBE;;;;;EAKE,wBAAA;AArBJ;AAwBE;EACE,UAAA;AAtBJ;AAyBE;EACE,kBAAA;AAvBJ;AA0BE;EACE,YAAA;AAxBJ;AA2BE;;;;;EAKE,gBAAA;EACA,6BAAA;EACA,mBAAA;AAzBJ;AA4BE;;;;;EAKE,8BAAA;AA1BJ;AA6BE;;;EAGE,gBAAA;EACA,6BAAA;AA3BJ;AA8BE;;;;;EAKE,sBAAA;EACA,6BAAA;EACA,aAAA;AA5BJ;AA+BE;;;EAGE,4BAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AA7BJ;AAgCE;;EAEE,WAAA;EACA,SAAA;EACA,UAAA;AA9BJ;AAiCE;EACE,wBAAA;AA/BJ;AAkCE;EACE,yBAAA;AAhCJ;AAmCE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AAjCJ;AAoCE;EACE,sBAAA;EACA,iBAAA;EACA,gBAAA;AAlCJ;AAqCE;EACE;;;;;IAAA;EAMA,WAAA;AAnCJ;AAsCE;;EAIE,gBAAA;AApCJ;AAuCE;EACE,YAAA;EACA,WAAA;AArCJ;AAwCE;EACE,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,4CAAA;EACA,oBAAA;AAtCJ;AAyCE;EACE,kBAAA;EACA,4CAAA;EACA,oCAAA;EACA,gGAAA;EAEA,8CAAA;EACA,wCAAA;EACA,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;AAxCJ;AA2CE;EACE,0CAAA;AAzCJ;AA4CE;EACE,qBAAA;AA1CJ;AA6CE;EACE,qBAAA;EACA,4CAAA;AA3CJ;AA8CE;EACE,qCAAA;EACA,2CAAA;EACA,4CAAA;AA5CJ;AA+CE;EACE,qBAAA;EACA,0CAAA;AA7CJ;AAgDE;;;;;;;;;;;;;;EAcE,eAAA;AA9CJ;AAiDE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AA/CJ;AAkDE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EAGA,iBAAA;EACA,oBAAA;AAhDJ;AAmDE;EACE,WAAA;EACA,qBAAA;AAjDJ;AAoDE;EACE;IACE,iCAAA;EAlDJ;AACF;AAqDE;EACE,YAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AAnDJ;AAsDE;EACE,iBAAA;AApDJ;AAuDE;EACE,0BAAA;AArDJ;AAwDE;EACE,0BAAA;AAtDJ;AAyDE;EACE,gBAAA;AAvDJ;AA0DE;EACE,oCAAA;AAxDJ;AA+DE;EACE,0BAAA;AA1DJ;AA6DE;EACE,gBAAA;EACA,kBAAA;AA3DJ;AA8DE;EACE,kBAAA;AA5DJ;AA+DE;EACE,aAAA;AA7DJ;AAgEE;EACE,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,qBAAA;EACA,gBAAA;AA9DJ;AAiEE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,oBAAA;AA/DJ;AAkEE;EACE,wBAAA;AAhEJ;AAmEE;EACE,oBAAA;AAjEJ;AAoEE;EACE,oBAAA;AAlEJ;AAqEE;EACE,oBAAA;AAnEJ;AAsEE;EACE,WAAA;AApEJ;AAuEE;EACE,gBAAA;AArEJ;AAwEE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAtEJ;AAyEE;EACE,gBAAA;EACA,cAAA;AAvEJ;AA0EE;EACE,gBAAA;EACA,cAAA;AAxEJ;AA2EE;EACE,YAAA;EACA,WAAA;AAzEJ;AA4EE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA1EJ;AA6EE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AA3EJ;AA8EE;;;;EAIE,gBAAA;AA5EJ;AA+EE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AA7EJ;AAgFE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AA9EJ;AAiFE;;;;EAIE,WAAA;AA/EJ;AAkFE;EACE,6BAAA;EACA,kBAAA;EACA,oBAAA;AAhFJ;AAmFE;EACE,WAAA;EACA,YAAA;AAjFJ;AAoFE;;EAEE,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,oBAAA;AAlFJ;AAqFE;;EAEE,aAAA;AAnFJ;AAsFE;;EAEE,YAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,uDAAA;AApFJ;AAuFE;;;;EAIE,cAAA;AArFJ;AAwFE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAtFJ;AAyFE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAvFJ;AA0FE;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAxFJ;AA2FE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AAzFJ;AA4FE;EAEE,yBAAA;EAEA,mBAAA;EACA,WAAA;EACA,YAAA;AA1FJ;AA6FE;;;EAGE,aAAA;EACA,sBAAA;EACA,oBAAA;AA3FJ;AA8FE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AA5FJ;AA+FE;EACE,aAAA;EACA,2BAAA;EACA,oBAAA;AA7FJ;AAgGE;EACE,qBAAA;AA9FJ;AAiGE;EACE,kBAAA;AA/FJ;AAkGE;EACE,kBAAA;AAhGJ;AAmGE;EACE,aAAA;EACA,mBAAA;AAjGJ;AAoGE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AAlGJ;AAqGE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAnGJ;AAsGE;EACE,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,OAAA;AApGJ;AAuGE;EACE,OAAA;AArGJ;AAwGE;;;;;;EAME,mBAAA;AAtGJ;AAyGE;EACE;;IAEE,uBAAA;EAvGJ;EA0GE;IAGE,gBAAA;IACA,gBAAA;IACA,iBAAA;EAxGJ;AACF;AA2GE;EACE,wBAAA;AAzGJ;AA2GE;EACE,yBAAA;AAzGJ;AA2GE;EACE,yBAAA;AAzGJ;AA4GE;EACE,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,4CAAA;EACA,qBAAA;AA1GJ;AA6GE;EACE,6BAAA;EACA,YAAA;AA3GJ;AA8GE;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,4DAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;AA5GJ;AA+GE;EACE,uBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,wCAAA;AA7GJ;AAgHE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AA9GJ;AAiHE;EACE,cAAA;AA/GJ;AAkHE;EACE,8BAAA;EACA,WAAA;AAhHJ;AAmHE;EACE,aAAA;AAjHJ;AAoHE;EACE,YAAA;AAlHJ;AAqHE;EACE,kBAAA;AAnHJ;AAsHE;;EAEE,6BAAA;AApHJ;AAuHE;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,YAAA;AArHJ;AAwHE;EACE,YAAA;EACA,gDAAA;AAtHJ;AAyHE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAvHJ;AA0HE;EACE,0CAAA;AAxHJ;AA0HE;EACE,iDAAA;AAxHJ;AA0HE;EACE,2CAAA;AAxHJ;AA2HE;EACE,+CAAA;AAzHJ;AA4HE;EACE,gBAAA;AA1HJ;AA6HE;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,sCAAA;EACA,4BAAA;EACA,oCAAA;AA3HJ;AA8HE;EACE,kBAAA;EACA,QAAA;EACA,sCAAA;AA5HJ;AA+HE;EACE,mBAAA;EACA,YAAA;AA7HJ;AAgIE;EACE,qBAAA;AA9HJ;AAiIE;EACE,SAAA;EACA,YAAA;AA/HJ;AAkIE;;;EAGE,kBAAA;EACA,mBAAA;EACA,kBAAA;AAhIJ;AAmIE;;EAEE,mBAAA;AAjIJ;AAoIE;;;EAGE,cAAA;EACA,eAAA;AAlIJ;AAqIE;;;;;;EAME,qBAAA;EACA,sBAAA;AAnIJ;AAsIE;;;EAGE,qDAAA;EACA,sDAAA;AApIJ;AAuIE;;;EAGE,gBAAA;EACA,iBAAA;AArIJ;AAwIE;EACE,SAAA;EACA,cAAA;AAtIJ;AAyIE;EACE,aAAA;AAvIJ;AA0IE;EACE,kBAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,shGAAA;AAxIJ;AA4IE;EACE,gBAAA;AA1IJ;AA6IE;EAGE,4BAAA;EACA,mBAAA;AA3IJ;AA8IE;EACE,iBAAA;AA5IJ;AA+IE;EACE,SAAA;AA7IJ;AAgJE;EACE,cAAA;EACA,6BAAA;AA9IJ","sourcesContent":[".ng2-pdf-viewer-container {\n  overflow-x: auto;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  -webkit-overflow-scrolling: touch;\n}\n\n:host {\n  display: block;\n  position: relative;\n}\n\n:host ::ng-deep {\n  /* Copyright 2014 Mozilla Foundation\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n  --pdfViewer-padding-bottom: 0;\n  --page-margin: 1px auto -8px;\n  --page-border: 9px solid transparent;\n  --spreadHorizontalWrapped-margin-LR: -3.5px;\n  --viewer-container-height: 0;\n  --annotation-unfocused-field-background: url(\"data:image/svg+xml;charset=UTF-8,<svg width='1px' height='1px' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill:rgba(0, 54, 255, 0.13);'/></svg>\");\n  --xfa-unfocused-field-background: var(\n    --annotation-unfocused-field-background\n  );\n  --page-border-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAA1ElEQVQ4jbWUWw6EIAxFy2NFs/8NzR4UJhpqLsdi5mOmSSMUOfYWqv3S0gMr4XlYH/64gZa/gN3ANYA7KAXALt4ktoQ5MI9YxqaG8bWmsIysMuT6piSQCa4whZThCu8CM4zP9YJaKci9jicPq3NcBWYoPMGUlhG7ivtkB+gVyFY75wXghOvh8t5mto1Mdim6e+MBqH6XsY+YAwjpq3vGF7weTWQptLEDVCZvPTMl5JZZsdh47FHW6qFMyvLYqjcnmdFfY9Xk/KDOlzCusX2mi/ofM7MPkzBcSp4Q1/wAAAAASUVORK5CYII=')\n    9 9 repeat;\n  --scale-factor: 1;\n\n  --focus-outline: solid 2px blue;\n  --hover-outline: dashed 2px blue;\n  --freetext-line-height: 1.35;\n  --freetext-padding: 2px;\n  --editorInk-editing-cursor: pointer;\n\n  @media screen and (forced-colors: active) {\n    --pdfViewer-padding-bottom: 9px;\n    --page-margin: 8px auto -1px;\n    --page-border: 1px solid CanvasText;\n    --page-border-image: none;\n    --spreadHorizontalWrapped-margin-LR: 3.5px;\n  }\n\n  @media (forced-colors: active) {\n    --focus-outline: solid 3px ButtonText;\n    --hover-outline: dashed 3px ButtonText;\n  }\n\n  .textLayer {\n    position: absolute;\n    text-align: initial;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    overflow: hidden;\n    opacity: 0.2;\n    line-height: 1;\n    -webkit-text-size-adjust: none;\n    -moz-text-size-adjust: none;\n    text-size-adjust: none;\n    forced-color-adjust: none;\n  }\n\n  .textLayer span,\n  .textLayer br {\n    color: transparent;\n    position: absolute;\n    white-space: pre;\n    cursor: text;\n    transform-origin: 0% 0%;\n  }\n\n  /* Only necessary in Google Chrome, see issue 14205, and most unfortunately\n   * the problem doesn't show up in \"text\" reference tests. */\n  .textLayer span.markedContent {\n    top: 0;\n    height: 0;\n  }\n\n  .textLayer .highlight {\n    margin: -1px;\n    padding: 1px;\n    background-color: rgba(180, 0, 170, 1);\n    border-radius: 4px;\n  }\n\n  .textLayer .highlight.appended {\n    position: initial;\n  }\n\n  .textLayer .highlight.begin {\n    border-radius: 4px 0 0 4px;\n  }\n\n  .textLayer .highlight.end {\n    border-radius: 0 4px 4px 0;\n  }\n\n  .textLayer .highlight.middle {\n    border-radius: 0;\n  }\n\n  .textLayer .highlight.selected {\n    background-color: rgba(0, 100, 0, 1);\n  }\n\n  .textLayer ::-moz-selection {\n    background: rgba(0, 0, 255, 1);\n  }\n\n  .textLayer ::selection {\n    background: rgba(0, 0, 255, 1);\n  }\n\n  /* Avoids https://github.com/mozilla/pdf.js/issues/13840 in Chrome */\n  .textLayer br::-moz-selection {\n    background: transparent;\n  }\n\n  .textLayer br::selection {\n    background: transparent;\n  }\n\n  .textLayer .endOfContent {\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 100%;\n    right: 0;\n    bottom: 0;\n    z-index: -1;\n    cursor: default;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n  }\n\n  .textLayer .endOfContent.active {\n    top: 0;\n  }\n\n  @media (forced-colors: active) {\n    .annotationLayer .textWidgetAnnotation input:required,\n    .annotationLayer .textWidgetAnnotation textarea:required,\n    .annotationLayer .choiceWidgetAnnotation select:required,\n    .annotationLayer .buttonWidgetAnnotation.checkBox input:required,\n    .annotationLayer .buttonWidgetAnnotation.radioButton input:required {\n      outline: 1.5px solid selectedItem;\n    }\n  }\n\n  .annotationLayer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n    transform-origin: 0 0;\n  }\n\n  .annotationLayer section {\n    position: absolute;\n    text-align: initial;\n    pointer-events: auto;\n    box-sizing: border-box;\n    transform-origin: 0 0;\n  }\n\n  .annotationLayer .linkAnnotation > a,\n  .annotationLayer .buttonWidgetAnnotation.pushButton > a {\n    position: absolute;\n    font-size: 1em;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .annotationLayer .buttonWidgetAnnotation.pushButton > canvas {\n    width: 100%;\n    height: 100%;\n  }\n\n  .annotationLayer .linkAnnotation > a:hover,\n  .annotationLayer .buttonWidgetAnnotation.pushButton > a:hover {\n    opacity: 0.2;\n    background: rgba(255, 255, 0, 1);\n    box-shadow: 0 2px 10px rgba(255, 255, 0, 1);\n  }\n\n  .annotationLayer .textAnnotation img {\n    position: absolute;\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n  }\n\n  .annotationLayer .textWidgetAnnotation input,\n  .annotationLayer .textWidgetAnnotation textarea,\n  .annotationLayer .choiceWidgetAnnotation select,\n  .annotationLayer .buttonWidgetAnnotation.checkBox input,\n  .annotationLayer .buttonWidgetAnnotation.radioButton input {\n    background-image: var(--annotation-unfocused-field-background);\n    border: 1px solid transparent;\n    box-sizing: border-box;\n    font: calc(9px * var(--scale-factor)) sans-serif;\n    height: 100%;\n    margin: 0;\n    vertical-align: top;\n    width: 100%;\n  }\n\n  .annotationLayer .textWidgetAnnotation input:required,\n  .annotationLayer .textWidgetAnnotation textarea:required,\n  .annotationLayer .choiceWidgetAnnotation select:required,\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:required,\n  .annotationLayer .buttonWidgetAnnotation.radioButton input:required {\n    outline: 1.5px solid red;\n  }\n\n  .annotationLayer .choiceWidgetAnnotation select option {\n    padding: 0;\n  }\n\n  .annotationLayer .buttonWidgetAnnotation.radioButton input {\n    border-radius: 50%;\n  }\n\n  .annotationLayer .textWidgetAnnotation textarea {\n    resize: none;\n  }\n\n  .annotationLayer .textWidgetAnnotation input[disabled],\n  .annotationLayer .textWidgetAnnotation textarea[disabled],\n  .annotationLayer .choiceWidgetAnnotation select[disabled],\n  .annotationLayer .buttonWidgetAnnotation.checkBox input[disabled],\n  .annotationLayer .buttonWidgetAnnotation.radioButton input[disabled] {\n    background: none;\n    border: 1px solid transparent;\n    cursor: not-allowed;\n  }\n\n  .annotationLayer .textWidgetAnnotation input:hover,\n  .annotationLayer .textWidgetAnnotation textarea:hover,\n  .annotationLayer .choiceWidgetAnnotation select:hover,\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:hover,\n  .annotationLayer .buttonWidgetAnnotation.radioButton input:hover {\n    border: 1px solid rgba(0, 0, 0, 1);\n  }\n\n  .annotationLayer .textWidgetAnnotation input:focus,\n  .annotationLayer .textWidgetAnnotation textarea:focus,\n  .annotationLayer .choiceWidgetAnnotation select:focus {\n    background: none;\n    border: 1px solid transparent;\n  }\n\n  .annotationLayer .textWidgetAnnotation input :focus,\n  .annotationLayer .textWidgetAnnotation textarea :focus,\n  .annotationLayer .choiceWidgetAnnotation select :focus,\n  .annotationLayer .buttonWidgetAnnotation.checkBox :focus,\n  .annotationLayer .buttonWidgetAnnotation.radioButton :focus {\n    background-image: none;\n    background-color: transparent;\n    outline: auto;\n  }\n\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after,\n  .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {\n    background-color: CanvasText;\n    content: '';\n    display: block;\n    position: absolute;\n  }\n\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before,\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {\n    height: 80%;\n    left: 45%;\n    width: 1px;\n  }\n\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:before {\n    transform: rotate(45deg);\n  }\n\n  .annotationLayer .buttonWidgetAnnotation.checkBox input:checked:after {\n    transform: rotate(-45deg);\n  }\n\n  .annotationLayer .buttonWidgetAnnotation.radioButton input:checked:before {\n    border-radius: 50%;\n    height: 50%;\n    left: 30%;\n    top: 20%;\n    width: 50%;\n  }\n\n  .annotationLayer .textWidgetAnnotation input.comb {\n    font-family: monospace;\n    padding-left: 2px;\n    padding-right: 0;\n  }\n\n  .annotationLayer .textWidgetAnnotation input.comb:focus {\n    /*\n     * Letter spacing is placed on the right side of each character. Hence, the\n     * letter spacing of the last character may be placed outside the visible\n     * area, causing horizontal scrolling. We avoid this by extending the width\n     * when the element has focus and revert this when it loses focus.\n     */\n    width: 103%;\n  }\n\n  .annotationLayer .buttonWidgetAnnotation.checkBox input,\n  .annotationLayer .buttonWidgetAnnotation.radioButton input {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n\n  .annotationLayer .popupTriggerArea {\n    height: 100%;\n    width: 100%;\n  }\n\n  .annotationLayer .popupWrapper {\n    position: absolute;\n    font-size: calc(9px * var(--scale-factor));\n    width: 100%;\n    min-width: calc(180px * var(--scale-factor));\n    pointer-events: none;\n  }\n\n  .annotationLayer .popup {\n    position: absolute;\n    max-width: calc(180px * var(--scale-factor));\n    background-color: rgba(255, 255, 153, 1);\n    box-shadow: 0 calc(2px * var(--scale-factor))\n      calc(5px * var(--scale-factor)) rgba(136, 136, 136, 1);\n    border-radius: calc(2px * var(--scale-factor));\n    padding: calc(6px * var(--scale-factor));\n    margin-left: calc(5px * var(--scale-factor));\n    cursor: pointer;\n    font: message-box;\n    white-space: normal;\n    word-wrap: break-word;\n    pointer-events: auto;\n  }\n\n  .annotationLayer .popup > * {\n    font-size: calc(9px * var(--scale-factor));\n  }\n\n  .annotationLayer .popup h1 {\n    display: inline-block;\n  }\n\n  .annotationLayer .popupDate {\n    display: inline-block;\n    margin-left: calc(5px * var(--scale-factor));\n  }\n\n  .annotationLayer .popupContent {\n    border-top: 1px solid rgba(51, 51, 51, 1);\n    margin-top: calc(2px * var(--scale-factor));\n    padding-top: calc(2px * var(--scale-factor));\n  }\n\n  .annotationLayer .richText > * {\n    white-space: pre-wrap;\n    font-size: calc(9px * var(--scale-factor));\n  }\n\n  .annotationLayer .highlightAnnotation,\n  .annotationLayer .underlineAnnotation,\n  .annotationLayer .squigglyAnnotation,\n  .annotationLayer .strikeoutAnnotation,\n  .annotationLayer .freeTextAnnotation,\n  .annotationLayer .lineAnnotation svg line,\n  .annotationLayer .squareAnnotation svg rect,\n  .annotationLayer .circleAnnotation svg ellipse,\n  .annotationLayer .polylineAnnotation svg polyline,\n  .annotationLayer .polygonAnnotation svg polygon,\n  .annotationLayer .caretAnnotation,\n  .annotationLayer .inkAnnotation svg polyline,\n  .annotationLayer .stampAnnotation,\n  .annotationLayer .fileAttachmentAnnotation {\n    cursor: pointer;\n  }\n\n  .annotationLayer section svg {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n  }\n\n  .annotationLayer .annotationTextContent {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    color: transparent;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n    pointer-events: none;\n  }\n\n  .annotationLayer .annotationTextContent span {\n    width: 100%;\n    display: inline-block;\n  }\n\n  @media (forced-colors: active) {\n    .xfaLayer *:required {\n      outline: 1.5px solid selectedItem;\n    }\n  }\n\n  .xfaLayer .highlight {\n    margin: -1px;\n    padding: 1px;\n    background-color: rgba(239, 203, 237, 1);\n    border-radius: 4px;\n  }\n\n  .xfaLayer .highlight.appended {\n    position: initial;\n  }\n\n  .xfaLayer .highlight.begin {\n    border-radius: 4px 0 0 4px;\n  }\n\n  .xfaLayer .highlight.end {\n    border-radius: 0 4px 4px 0;\n  }\n\n  .xfaLayer .highlight.middle {\n    border-radius: 0;\n  }\n\n  .xfaLayer .highlight.selected {\n    background-color: rgba(203, 223, 203, 1);\n  }\n\n  .xfaLayer ::-moz-selection {\n    background: rgba(0, 0, 255, 1);\n  }\n\n  .xfaLayer ::selection {\n    background: rgba(0, 0, 255, 1);\n  }\n\n  .xfaPage {\n    overflow: hidden;\n    position: relative;\n  }\n\n  .xfaContentarea {\n    position: absolute;\n  }\n\n  .xfaPrintOnly {\n    display: none;\n  }\n\n  .xfaLayer {\n    position: absolute;\n    text-align: initial;\n    top: 0;\n    left: 0;\n    transform-origin: 0 0;\n    line-height: 1.2;\n  }\n\n  .xfaLayer * {\n    color: inherit;\n    font: inherit;\n    font-style: inherit;\n    font-weight: inherit;\n    font-kerning: inherit;\n    letter-spacing: -0.01px;\n    text-align: inherit;\n    text-decoration: inherit;\n    box-sizing: border-box;\n    background-color: transparent;\n    padding: 0;\n    margin: 0;\n    pointer-events: auto;\n    line-height: inherit;\n  }\n\n  .xfaLayer *:required {\n    outline: 1.5px solid red;\n  }\n\n  .xfaLayer div {\n    pointer-events: none;\n  }\n\n  .xfaLayer svg {\n    pointer-events: none;\n  }\n\n  .xfaLayer svg * {\n    pointer-events: none;\n  }\n\n  .xfaLayer a {\n    color: blue;\n  }\n\n  .xfaRich li {\n    margin-left: 3em;\n  }\n\n  .xfaFont {\n    color: black;\n    font-weight: normal;\n    font-kerning: none;\n    font-size: 10px;\n    font-style: normal;\n    letter-spacing: 0;\n    text-decoration: none;\n    vertical-align: 0;\n  }\n\n  .xfaCaption {\n    overflow: hidden;\n    flex: 0 0 auto;\n  }\n\n  .xfaCaptionForCheckButton {\n    overflow: hidden;\n    flex: 1 1 auto;\n  }\n\n  .xfaLabel {\n    height: 100%;\n    width: 100%;\n  }\n\n  .xfaLeft {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .xfaRight {\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n  }\n\n  .xfaLeft > .xfaCaption,\n  .xfaLeft > .xfaCaptionForCheckButton,\n  .xfaRight > .xfaCaption,\n  .xfaRight > .xfaCaptionForCheckButton {\n    max-height: 100%;\n  }\n\n  .xfaTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .xfaBottom {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: flex-start;\n  }\n\n  .xfaTop > .xfaCaption,\n  .xfaTop > .xfaCaptionForCheckButton,\n  .xfaBottom > .xfaCaption,\n  .xfaBottom > .xfaCaptionForCheckButton {\n    width: 100%;\n  }\n\n  .xfaBorder {\n    background-color: transparent;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  .xfaWrapped {\n    width: 100%;\n    height: 100%;\n  }\n\n  .xfaTextfield:focus,\n  .xfaSelect:focus {\n    background-image: none;\n    background-color: transparent;\n    outline: auto;\n    outline-offset: -1px;\n  }\n\n  .xfaCheckbox:focus,\n  .xfaRadio:focus {\n    outline: auto;\n  }\n\n  .xfaTextfield,\n  .xfaSelect {\n    height: 100%;\n    width: 100%;\n    flex: 1 1 auto;\n    border: none;\n    resize: none;\n    background-image: var(--xfa-unfocused-field-background);\n  }\n\n  .xfaTop > .xfaTextfield,\n  .xfaTop > .xfaSelect,\n  .xfaBottom > .xfaTextfield,\n  .xfaBottom > .xfaSelect {\n    flex: 0 1 auto;\n  }\n\n  .xfaButton {\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n    border: none;\n    text-align: center;\n  }\n\n  .xfaLink {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  .xfaCheckbox,\n  .xfaRadio {\n    width: 100%;\n    height: 100%;\n    flex: 0 0 auto;\n    border: none;\n  }\n\n  .xfaRich {\n    white-space: pre-wrap;\n    width: 100%;\n    height: 100%;\n  }\n\n  .xfaImage {\n    -o-object-position: left top;\n    object-position: left top;\n    -o-object-fit: contain;\n    object-fit: contain;\n    width: 100%;\n    height: 100%;\n  }\n\n  .xfaLrTb,\n  .xfaRlTb,\n  .xfaTb {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .xfaLr {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n  }\n\n  .xfaRl {\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: stretch;\n  }\n\n  .xfaTb > div {\n    justify-content: left;\n  }\n\n  .xfaPosition {\n    position: relative;\n  }\n\n  .xfaArea {\n    position: relative;\n  }\n\n  .xfaValignMiddle {\n    display: flex;\n    align-items: center;\n  }\n\n  .xfaTable {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .xfaTable .xfaRow {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n  }\n\n  .xfaTable .xfaRlRow {\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: stretch;\n    flex: 1;\n  }\n\n  .xfaTable .xfaRlRow > div {\n    flex: 1;\n  }\n\n  .xfaNonInteractive input,\n  .xfaNonInteractive textarea,\n  .xfaDisabled input,\n  .xfaDisabled textarea,\n  .xfaReadOnly input,\n  .xfaReadOnly textarea {\n    background: initial;\n  }\n\n  @media print {\n    .xfaTextfield,\n    .xfaSelect {\n      background: transparent;\n    }\n\n    .xfaSelect {\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      text-indent: 1px;\n      text-overflow: '';\n    }\n  }\n\n  [data-editor-rotation='90'] {\n    transform: rotate(90deg);\n  }\n  [data-editor-rotation='180'] {\n    transform: rotate(180deg);\n  }\n  [data-editor-rotation='270'] {\n    transform: rotate(270deg);\n  }\n\n  .annotationEditorLayer {\n    background: transparent;\n    position: absolute;\n    top: 0;\n    left: 0;\n    font-size: calc(100px * var(--scale-factor));\n    transform-origin: 0 0;\n  }\n\n  .annotationEditorLayer .selectedEditor {\n    outline: var(--focus-outline);\n    resize: none;\n  }\n\n  .annotationEditorLayer .freeTextEditor {\n    position: absolute;\n    background: transparent;\n    border-radius: 3px;\n    padding: calc(var(--freetext-padding) * var(--scale-factor));\n    resize: none;\n    width: auto;\n    height: auto;\n    z-index: 1;\n    transform-origin: 0 0;\n    touch-action: none;\n  }\n\n  .annotationEditorLayer .freeTextEditor .internal {\n    background: transparent;\n    border: none;\n    top: 0;\n    left: 0;\n    overflow: visible;\n    white-space: nowrap;\n    resize: none;\n    font: 10px sans-serif;\n    line-height: var(--freetext-line-height);\n  }\n\n  .annotationEditorLayer .freeTextEditor .overlay {\n    position: absolute;\n    display: none;\n    background: transparent;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  .annotationEditorLayer .freeTextEditor .overlay.enabled {\n    display: block;\n  }\n\n  .annotationEditorLayer .freeTextEditor .internal:empty::before {\n    content: attr(default-content);\n    color: gray;\n  }\n\n  .annotationEditorLayer .freeTextEditor .internal:focus {\n    outline: none;\n  }\n\n  .annotationEditorLayer .inkEditor.disabled {\n    resize: none;\n  }\n\n  .annotationEditorLayer .inkEditor.disabled.selectedEditor {\n    resize: horizontal;\n  }\n\n  .annotationEditorLayer .freeTextEditor:hover:not(.selectedEditor),\n  .annotationEditorLayer .inkEditor:hover:not(.selectedEditor) {\n    outline: var(--hover-outline);\n  }\n\n  .annotationEditorLayer .inkEditor {\n    position: absolute;\n    background: transparent;\n    border-radius: 3px;\n    overflow: auto;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    transform-origin: 0 0;\n    cursor: auto;\n  }\n\n  .annotationEditorLayer .inkEditor.editing {\n    resize: none;\n    cursor: var(--editorInk-editing-cursor), pointer;\n  }\n\n  .annotationEditorLayer .inkEditor .inkEditorCanvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    touch-action: none;\n  }\n\n  [data-main-rotation='90'] {\n    transform: rotate(90deg) translateY(-100%);\n  }\n  [data-main-rotation='180'] {\n    transform: rotate(180deg) translate(-100%, -100%);\n  }\n  [data-main-rotation='270'] {\n    transform: rotate(270deg) translateX(-100%);\n  }\n\n  .pdfViewer {\n    padding-bottom: var(--pdfViewer-padding-bottom);\n  }\n\n  .pdfViewer .canvasWrapper {\n    overflow: hidden;\n  }\n\n  .pdfViewer .page {\n    direction: ltr;\n    width: 816px;\n    height: 1056px;\n    margin: var(--page-margin);\n    position: relative;\n    overflow: visible;\n    border: var(--page-border);\n    -o-border-image: var(--page-border-image);\n    border-image: var(--page-border-image);\n    background-clip: content-box;\n    background-color: rgba(255, 255, 255, 1);\n  }\n\n  .pdfViewer .dummyPage {\n    position: relative;\n    width: 0;\n    height: var(--viewer-container-height);\n  }\n\n  .pdfViewer.removePageBorders .page {\n    margin: 0 auto 10px;\n    border: none;\n  }\n\n  .pdfViewer.singlePageView {\n    display: inline-block;\n  }\n\n  .pdfViewer.singlePageView .page {\n    margin: 0;\n    border: none;\n  }\n\n  .pdfViewer.scrollHorizontal,\n  .pdfViewer.scrollWrapped,\n  .spread {\n    margin-left: 3.5px;\n    margin-right: 3.5px;\n    text-align: center;\n  }\n\n  .pdfViewer.scrollHorizontal,\n  .spread {\n    white-space: nowrap;\n  }\n\n  .pdfViewer.removePageBorders,\n  .pdfViewer.scrollHorizontal .spread,\n  .pdfViewer.scrollWrapped .spread {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .spread .page,\n  .spread .dummyPage,\n  .pdfViewer.scrollHorizontal .page,\n  .pdfViewer.scrollWrapped .page,\n  .pdfViewer.scrollHorizontal .spread,\n  .pdfViewer.scrollWrapped .spread {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .spread .page,\n  .pdfViewer.scrollHorizontal .page,\n  .pdfViewer.scrollWrapped .page {\n    margin-left: var(--spreadHorizontalWrapped-margin-LR);\n    margin-right: var(--spreadHorizontalWrapped-margin-LR);\n  }\n\n  .pdfViewer.removePageBorders .spread .page,\n  .pdfViewer.removePageBorders.scrollHorizontal .page,\n  .pdfViewer.removePageBorders.scrollWrapped .page {\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n\n  .pdfViewer .page canvas {\n    margin: 0;\n    display: block;\n  }\n\n  .pdfViewer .page canvas[hidden] {\n    display: none;\n  }\n\n  .pdfViewer .page .loadingIcon {\n    position: absolute;\n    display: block;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: url('data:image/gif;base64,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')\n      center no-repeat;\n  }\n\n  .pdfViewer .page .loadingIcon.notVisible {\n    background: none;\n  }\n\n  .pdfViewer.enablePermissions .textLayer span {\n    -webkit-user-select: none !important;\n    -moz-user-select: none !important;\n    user-select: none !important;\n    cursor: not-allowed;\n  }\n\n  .pdfPresentationMode .pdfViewer {\n    padding-bottom: 0;\n  }\n\n  .pdfPresentationMode .spread {\n    margin: 0;\n  }\n\n  .pdfPresentationMode .pdfViewer .page {\n    margin: 0 auto;\n    border: 2px solid transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
